/*
 * Main Javascript file for herbal.
 *
 * This file bundles all of your javascript together using webpack.
 */

// JavaScript modules
require('jquery');
require('./script.js');



// WEBPACK FOOTER //
// ./herbal/static/js/main.js